import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { SportBall } from '@sorare/core/src/atoms/icons/SportBall';
import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { BodyM, LabelS } from '@sorare/core/src/atoms/typography';
import { ClubShield } from '@sorare/core/src/components/user/ClubShield';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { getFormattedSport } from '@sorare/core/src/lib/sports';

type Props = {
  sport: Sport;
  clubName?: string | null;
  shieldUrl?: string | null;
  to: string;
  onboarded?: boolean;
};

const StyledButton = styled(Button)`
  flex-shrink: 0;
`;

export const SportClub = ({
  sport,
  clubName,
  shieldUrl,
  to,
  onboarded,
}: Props) => {
  const { sport: sportContext } = useSportContext();

  if (sport === sportContext) return null;

  const hasClub = onboarded && clubName;

  return (
    <SBHorizontal gap={1.5}>
      <Horizontal gap={1.5}>
        <ClubShield size={5} shieldUrl={shieldUrl} clubName={clubName} />
        <Vertical gap={0}>
          <Horizontal gap={0.5}>
            <LabelS as="span" color="var(--c-neutral-1000)">
              <SportBall size={2} sport={sport} />
            </LabelS>
            <LabelS as="span" color="var(--c-neutral-600)">
              {getFormattedSport(sport)}
            </LabelS>
          </Horizontal>
          <BodyM
            as="p"
            bold
            color={hasClub ? undefined : 'var(--c-yellow-600)'}
            title={hasClub ? clubName : undefined}
          >
            {hasClub ? (
              clubName
            ) : (
              <>
                <FormattedMessage
                  id="Profile.OtherClubs.SportClub.noClubYet"
                  defaultMessage="No club yet"
                />{' '}
                <FontAwesomeIcon icon={faWarning} />
              </>
            )}
          </BodyM>
        </Vertical>
      </Horizontal>
      <StyledButton color="tertiary" size="medium" to={to}>
        <FormattedMessage
          id="Profile.OtherClubs.SportClub.see"
          defaultMessage="See"
        />
      </StyledButton>
    </SBHorizontal>
  );
};
